import * as _4 from 'lodash4';
import { IModalData } from '../../modals/placement_test_tile_modal_service';

export interface IOtherTestScoresData {
  name: string;
  score: string;
}
export class PlacementTestScoresTile {
  section: any;
  courses: any;
  testTooltipContent: string;
  isScoreVisible: boolean = false;
  showScores: boolean;
  messageConditions: Record<string, string>;
  otherTestScoresData: IOtherTestScoresData[];
  developmentalCoursesModalContent: string;
  modalData: {
    isOpen: boolean;
    data: IModalData;
  };

  constructor(private phxFeatureConfiguration: any) {}

  $onInit(): void {
    this.courses = this.getCoursesInSection();
    this.otherTestScoresData = this.otherTestScores();
    this.showScores = this.showScores ? this.showScores : true;
    this.messageConditions = {
      0: ' developmental courses',
      one: 'a developmental course',
      other: ' developmental courses'
    };
    this.developmentalCoursesModalContent = `<p class="mbs"> Developmental Courses prepare you for college level work.When planning your schedule, take these courses first to be eligible to take you major courses.</p>
        <p class="text">These courses do not count towards your degree requirements and will add time in school.
            Contact an academic  ${
              this.phxFeatureConfiguration.read('student-platform.roles.advisor-title.lowercase').assignContent
            }
             to talk about your required developmental courses.</p>`;
  }

  numPlacementGroups(): number {
    return _4.keys(this.section._courses_by_group_nk).length;
  }

  hasCoursesInSection(): boolean {
    return !_4.isEmpty(_4.flatten(_4.values(this.section._courses_by_group_nk)));
  }

  showDevelopmentalCoursesDesc(): void {
    this.modalData = {
      data: {
        title: 'Developmental Courses',
        content: this.developmentalCoursesModalContent
      },
      isOpen: true
    };
  }

  showNoscoresYetDesc(): void {
    this.modalData = {
      data: {
        title: 'Take the Placement Test!',
        content: `<p class="text mbs">Colleges use placement tests in subjects like Math and English to check the academic skill levels of entering students. Then the college can place each student in classes at the right level.</p>`
      },
      isOpen: true
    };
  }
  getCoursesInSection(): any {
    return _4.union(_4.flatten(_4.values(this.section._courses_by_group_nk)));
  }

  hasTests(): boolean {
    return !_4.isEmpty(this.section._tests);
  }

  hasTestsOnPath(): boolean {
    return !_4.isEmpty(this.section._tests_on_path);
  }

  hasBestTestsOffPath(): boolean {
    let testsExist = false;

    _4.each(this.section._best_tests_by_nk, (test) => {
      testsExist = testsExist || _4.includes(this.section._tests_off_path, test);
    });

    return testsExist;
  }

  otherTests(): any {
    const allTests = this.section._tests;
    const bestTests = _4.flatten(_4.values(this.section._best_tests_by_nk));
    return _4.difference(allTests, bestTests);
  }

  hasOtherTests(): boolean {
    return !_4.isEmpty(this.otherTests());
  }
  otherTestScores(): any {
    return _4.map(this.otherTests(), (test: any) => {
      return { name: test.name, score: test.score };
    });
  }

  isTestOnPath(test: any): boolean {
    return _4.includes(this.section._tests_on_path, test);
  }

  isTestOffPath(test: any): boolean {
    return _4.includes(this.section._tests_off_path, test);
  }

  scoresToDegrees(score: number, maxScore: number): number {
    return -Math.round((score / maxScore) * 360);
  }

  isEmptyTest(test: any): boolean {
    return _4.isEmpty(test);
  }

  iconClass(): string {
    if (!this.hasCoursesInSection() && !this.hasTests()) {
      return 'eab-icon-book';
    }

    return this.hasCoursesInSection() ? 'eab-icon-book' : 'eab-icon-smile-o';
  }

  tileClass(): string {
    return this.section.isScoreVisible ? 'pbm' : '';
  }

  onClick_showScores(): void {
    this.isScoreVisible = !this.isScoreVisible;
  }
}

angular.module('biz-ng-path-placement').component('placementTestScoresTile', {
  bindings: {
    section: '<',
    showScores: '<'
  },
  controller: PlacementTestScoresTile,
  templateUrl: 'biz-ng-path-placement/src/components/placement_test_scores_tile/placement_test_scores_tile.html'
});



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-path-placement/src/components/placement_test_scores_tile/placement_test_scores_tile.ts